import React, { useEffect, useState } from "react";
import Pic1 from "./../../assets/img/sumitrana.jpg";
import Pic2 from "./../../assets/img/Ramesh-Chander-Bidhan-IAS-Indian-Bureaucracy_1.jpg";
import Pic3 from "./../../assets/img/NarhariSinghBangerIAS.jpg";
import Pic4 from "./../../assets/img/drkcsahoo.jpg";
import Pic5 from "./../../assets/img/Sh_Nanu Ram Yadav_1.jpg";
import Pic6 from "./../../assets/img/darasingh.jpg";
import Pic7 from "./../../assets/img/manojkumar.jpg";
import { useLocation } from "react-router-dom";
import axios from "axios";
import BaseUrl from "../../base-api";
import Loader from "../Loader/Loader";
import { toast } from "react-toastify";

const Directors = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const [images, setImages] = useState([]);
  
      useEffect(() => {
        const fetchData = async () => {
          setLoading(true);
          try {
            const res = await axios.post(
              `${BaseUrl}/api/director/getAll`,
              { location: "Directors" },
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
    
            if (res.data.status === 200 && Array.isArray(res.data.data)) {
              const processedImages = res.data.data.map((img) => ({
                id: img.key,
                location: img.location,
                imageUrl: img.file ? `data:image/png;base64,${img.file}` : "",
                name:img.name,
                designation:img.designation,
                mobileNo:img.mobileNo,
                officeNo:img.officeNo,
                email:img.email,
                address:img.address,
              }));
    
              setImages(processedImages);
            } else {
              toast.error(res.data.message || "Failed to load images.");
            }
  
          } catch (error) {
            toast.error(error.response?.data?.message || "An error occurred");
          }
          finally{
            setLoading(false);
          }
        };
    
        if (location.pathname) fetchData();
      }, [location.pathname]);
  return (
    <>
    {loading ? (
      <Loader />
    ) : (
    <div className="container my-3">
      <div className="abouts">
        <h5>Directors</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        
      >
        <h6>HARYANA SEEDS DEVELOPMENT CORPORATION LIMITED</h6>

        <p>(A STATE GOVT. UNDERTAKING)</p>

        <p>BEEJ BHAWAN, BAYS 3-6, SECTOR-2, PANCHKULA</p>

        <p>PHONE :  0172-2577755</p>
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <tbody>
              <tr>
                <td colspan="6">
                  <strong>Board OF DIRECTORS</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>S.No.</strong>
                </td>
                <td>
                  <strong>Name &amp; Address</strong>
                </td>
                <td>
                  <strong>Designation</strong>
                </td>
                <td>
                  <strong>Phone No.</strong>
                </td>
                <td>
                  <strong>Email</strong>
                </td>
                <td>
                  <strong>Photo</strong>
                </td>
              </tr>
              {images.length > 0 ? (
                            images.map((img,index) => (
                              <tr key={img.id}>
                                <td>{index+1}</td>
                                <td>{img.name} <br/> {img.address}</td>
                                <td>{img.designation}</td>
                                <td>{img.officeNo}</td>
                                <td>{img.email}</td>
                                <td>
                                  {img.imageUrl ? (
                                    <img
                                      src={img.imageUrl}
                                      alt={img.location}
                                      width="140"
                                      height="120"
                                    />
                                  ) : (
                                    "No Image"
                                  )}
                                </td>
                                
                                
                                
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={6} className="text-center">
                                No Data Found.
                              </td>
                            </tr>
                          )}
              {/* <tr>
                <td>1</td>
                <td>
                  <p>
                    Sh. Sumit Rana<br></br>S/o Sh. Ramesh Kumar</p>
                    <p>VPO
                    Shahpur Turk, Sonepat
                  </p>

                  <p>&nbsp;</p>
                </td>
                <td>Chairman</td>
                <td>0172-2581877</td>
                <td>chairmanhsdcl@gmail.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic1} style={{width: '75px', height: '75px'}}
                    title=""
                  />
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                  <p>Sh. Ramesh Chander Bidhan, IAS</p>

                  <p>
                    Haryana Seeds Development Corporation Ltd.<br></br>
                    Bays 3-6, Sector-2, Panchkula, Haryana.
                  </p>

                  <p>&nbsp;</p>
                </td>
                <td>Managing Director</td>
                <td>0172-2577582, 2577583</td>
                <td>mdhsdcl@gmail.com</td>
                <td>
                  <img
                    alt="img-9"
                    src={Pic2} style={{width: '65px', height: '75px'}}
                  />
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>
                  <p>Sh. Narhari Singh Banger, IAS</p>

                  <p>
                    Director General <br></br>
                    Agriculture and Farmers Welfare Department, Krishi Bhawan,
                    Sector 21, Panchkula, Haryana.
                  </p>

                  <p>&nbsp;</p>
                </td>
                <td>Director</td>
                <td>0172-2570662</td>
                <td>agriharyana2009@gmail.com</td>
                <td>
                  <img
                    alt="img-3"
                    src={Pic3} style={{width: '65px', height: '75px'}}
                   
                    title="img-3"
                  />
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>
                  <p>Dr. Maninder Kaur Dwivedi, IAS</p>

                  <p>
                    Chairperson-cum-Managing Director<br></br>
                    National Seeds Corporation Ltd.<br></br>
                    Beej Bhawan, PUSA Complex, <br></br>
                    New Delhi-110012
                  </p>

                  <p>&nbsp;</p>
                </td>
                <td>Director</td>
                <td></td>
                <td>cmd@indiaseeds.com</td>
                <td>
                  <img
                    alt=""
                    src={""}
                    title=""
                  />
                </td>
              </tr>
              <tr>
                <td>5</td>
                <td>
                  <p>Dr. K.C. Sahoo</p>

                  <p>
                    Director (Commercial)
                    <br />
                    National Seeds Corporation Limited,
                    <br />
                    Beej Bhawan, PUSA Complex
                    <br />
                    New Delhi-110012
                  </p>

                  <p>&nbsp;</p>
                </td>
                <td>Director</td>
                <td></td>
                <td>dir.comml@indiaseeds.com</td>
                <td>
                  <img
                    alt="img-5"
                    src={Pic4} style={{width: '75px', height: '75px'}}
                    title="img-5"
                  />
                </td>
              </tr>
              <tr>
                <td>6</td>
                <td>
                  <p>Sh. Nanu Ram Yadav,</p>

                  <p>
                    Regional Manager,<br></br>
                    National Seeds Corporation Ltd.,<br></br>
                    Plot No.24, Industrial Phase IX,<br></br>
                    Mohali (Punjab) Pin - 160062,<br></br>
                    Regional Office Mohali-Chandigarh,<br></br>
                    Chandigarh
                  </p>

                  <p>&nbsp;</p>
                </td>
                <td>Director</td>
                <td>
                  0172-2214388,<br></br>
                  0172-2215388,<br></br>
                  0172-2213388 (FAX),<br></br>
                  70871-49999
                </td>
                <td>rm.chandigarh@indiaseeds.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic5} style={{width: '62px', height: '75px'}}
                    title=""
                  />
                </td>
              </tr>
              <tr>
                <td>7</td>
                <td>
                  <p>
                    Sh. Dara Singh<br></br>
                    S/o Sh. Ram Chander
                  </p>

                  <p>
                    VPO – Bhuthan Kalan,<br></br>
                    Distt. Fatehabad-125050
                  </p>

                  <p>&nbsp;</p>
                </td>
                <td>Director</td>
                <td>99964-63264</td>
                <td>lotasradarasingh@gmail.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic6} style={{width: '66px', height: '75px'}}
                    title=""
                  />
                </td>
              </tr>
              <tr>
                <td>8</td>
                <td>
                  <p>
                    Sh. Manoj Kumar<br></br>
                    S/o Sh. Dilbag singh</p>
                    <p>
                    Vill. Badhai Khera, P.O. <br></br>
                    Dangra, Teh. Tohana, <br></br>
                    Distt. Fatehabad-125120
                  </p>

                  <p>&nbsp;</p>
                </td>
                <td>Director</td>
                <td>95402-10000,</td>
                <td>sahilshehrawa+7@gmail.com</td>
                <td>
                  <img
                    alt=""
                    src={Pic7} style={{width: '65px', height: '75px'}}
                    title=""
                  />
                </td>
              </tr> */}
            </tbody>
          </table>
        </div>
      </div>
    </div>
     )}
    </>
  );
};

export default Directors;
